import { configureStore } from "@reduxjs/toolkit";
import InvoicesReducer from "../Feature/Invoices";
import featureFlagReducer from "../Feature/featureFlag";

export default configureStore({
  reducer: {
    featureFlag: featureFlagReducer,
    Invoices: InvoicesReducer,
  },
});

const store = configureStore({
  reducer: {
    featureFlag: featureFlagReducer,
    Invoices: InvoicesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
